import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';

export const TotalIncentivesAnual = () => {
    const { chartData } = useValuesChartsDataContext();

    return (
        <SimpleBars
            title={'Valor Total de Incentivos (Anual)'}
            horizontal={false}
            subtitles={chartData?.totalIncentivesAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.totalIncentivesAnual?.map((item) => item.value || 0)}
        />
    );
};
